import React from 'react'
import { Link } from 'react-router-relative-link'
import { bindActionCreators } from 'redux'
import { push } from "connected-react-router"
import { connect } from 'react-redux'
import { Field, FieldType, SortableField, Table } from '../../table'
import { setActiveAgency } from '../../../../modules/agency'
import swal from 'sweetalert'
import Api from '../../../../utils/api'

class AgencyMainPage extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
    }

    this.tableStruct = [
      SortableField(FieldType.NONE, 'id', 'ID'),
      SortableField(FieldType.NONE, 'name', 'Имя'),
      SortableField(FieldType.NONE, 'city', 'Город'),
      SortableField(FieldType.NONE, 'chiefId', 'ID реэлтора'),
      SortableField(FieldType.NONE, 'color', 'Цвет'),
      SortableField(FieldType.BUTTON, 'delete', 'Удалить'),
      SortableField(FieldType.BUTTON, 'edit', 'Редактировать'),
    ];

  }

  componentDidMount() {
  }

  tableHandler = (action, value) => {
    let item = this.props.data.find(item => item.id === value);

    switch (action) {
      case 'delete':
        if(item) {
          swal({ title: "Вы уверены?", icon: "warning", buttons: ["Нет", "Да"] })
            .then((ok) => {
              if(ok) {
                Api.delete('/agency/' + item.id)
                  .then(data => {
                    this.setState({ data: data.value || [] });
                    this.props.updateAgency();
                  });
              }
            });
        }

        break;

      case 'edit':
        if (item) {
          this.props.setActiveAgency(item);
          this.props.changePage('/admin/agency/edit');
        }

      default:
        break;
    }
  }

  render() {
    let data = this.props.data || [];

    data = data.map(item => {
      return ({
        ...item,
        edit: true,
        delete: true
      })
    });

    return (
      <div className="row">
        <div>
          <button className="btn btn-sm btn-info" onClick={() => this.props.changePage('/admin/agency/create')}>Создать</button>
        </div>
        <div style={{overflow: 'hidden'}}>
          <Table data={data} struct={this.tableStruct} onAction={this.tableHandler}/>
        </div>
      </div>
    )
  }

}

const mapStateToProps = ({ user, general, router, agency }) => ({
  user,
  general,
  agency,
  location: router.location
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setActiveAgency,
      changePage: (page) => push(page)
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgencyMainPage)
